<template>
  <div>
    <section class="pt-4 mb-4">
      <div class="container text-center">
        <div class="row">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="fw-600 h4">{{ $t("限时秒杀") }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
              class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
            >
              <li class="breadcrumb-item opacity-50">
                <a
                  class="text-reset"
                  href="javascript:void(0)"
                  @click="goto('/')"
                >
                  {{ $t("首页") }}
                </a>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0)">
                  {{ $t("限时秒杀") }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-4">
      <div class="container">
        <div v-if="poster" class="rich-text" v-html="getFileViewContent(poster.content)"></div>
<!--        <div class="row row-cols-1 row-cols-lg-2 gutters-10">-->
<!--          <div class="col">-->
<!--            <div class="bg-white rounded shadow-sm mb-3">-->
<!--              <a class="d-block text-reset">-->
<!--                <img-->
<!--                  alt="22 year promotion"-->
<!--                  class="img-fluid rounded w-100 lazyloaded"-->
<!--                  src="/static/uploads/all/HrXj6xaBM6NOR9sM5K7ZCHAjk5HNsv1uYcocl3JE.png"-->
<!--                />-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </section>
  </div>
</template>


<script>

export default {
  name: 'FlashDeals',
  components: { },
  data() {
    return {
      poster: null
    }
  },
  async created() {
    this.poster = await this.getPoster("flashDeals") || {}
  },
}
</script>